import { LoadingSpinnerIconTwoTone } from '@room-match/shared-ui-components';
import React from 'react';

type Props = {
  isLoading: boolean;
};
const Loader: React.FC<Props> = ({ isLoading }) => {
  return (
    <div
      style={{
        position: 'absolute',
        left: '50%',
        top: ' 50%',
        zIndex: 9999,
        transform: 'translate(-50%,-50%)',
      }}
    >
      {isLoading && <LoadingSpinnerIconTwoTone style={{ fontSize: '10em' }} />}
    </div>
  );
};

export default React.memo(Loader, (prev, curr) => prev.isLoading === curr.isLoading);
